<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <!-- <img src="img/avatars/6.jpg" class="img-avatar" alt=""> -->
      <div style="margin-right: 20px;">
        {{this.user.name}} {{this.user.last_name}}
      </div>
    
    </template>\
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <strong>Ajustes</strong>
      </b-dropdown-header>
      <b-dropdown-item @click="account">
        <i class="fa fa-user"/> Cuenta
      </b-dropdown-item>
      <b-dropdown-item @click="signOut">
        <i class="fa fa-lock"/> Salir
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import { mapGetters } from 'vuex'
export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 };
  },
  computed: {
    ...mapGetters(
      { 'user': 'user/user' }
    )
  },
  methods: {
    signOut() {
      this.$store.dispatch('user/resetUserState')
      localStorage.clear();
      this.$router.go('/login')
    },
    account(){
      this.$router.push('/account');
    }
  }
};
</script>
